<div class="select-box" [class.select-box--disabled]="disabled">
    <img
        class="select-box--img"
        [src]="imageUrl"
        [alt]="title"
        defaultImg
        *ngIf="!colorSelect && imageUrl"
    />
    <div
        *ngIf="colorSelect"
        class="select-box--color"
    >
        <span
            [style.backgroundColor]="color"
            [style.backgroundImage]="'url(' + imageUrl + ')'"
        ></span>
    </div>
    <p class="select-box--title">{{ title }}</p>
    <p class="select-box--description" [innerHtml]="description" *ngIf="!descriptionTemplate"></p>
    <div class="select-box--description" *ngIf="descriptionTemplate">
        <ng-container
            [ngTemplateOutlet]="descriptionTemplate"
            [ngTemplateOutletContext]="descriptionContext"
        ></ng-container>
    </div>
    <div class="select-box--button">
        <button
            [disabled]="disabled || disabledButton1"
            mat-raised-button
            color="primary"
            (click)="select.emit()"
            *ngIf="buttonText"
        >
            {{ buttonText | uppercase }}
        </button>
        <button
            [disabled]="disabled || disabledButton2"
            mat-raised-button
            color="primary"
            (click)="select2.emit()"
            *ngIf="buttonText2"
        >
            {{ buttonText2 | uppercase }}
        </button>
        <button
            [disabled]="disabled || disabledButton3"
            mat-raised-button
            color="primary"
            (click)="select3.emit()"
            *ngIf="buttonText3"
        >
            {{ buttonText3 | uppercase }}
        </button>
    </div>
</div>
